module.exports = __webpack_public_path__ + "static/img/pos_machine.1a80cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_machine.png
// module id = DloI
// module chunks = 8